export function formatBytesPerSecond(bytesPerSecond) {
  if(bytesPerSecond){
  return bytetoUnit(bytesPerSecond, ["B/s", "KB/s", "MB/s", "GB/s", "TB/s"]);}
  else{
    return 0+"B/s"
  }

}
export function formatBytes(bytes) {
  if(bytes){
  return bytetoUnit(bytes, ["B", "KB", "MB", "GB", "TB"]);}
  else{
    return 0+"B"
  }
}
export function bytetoUnit(bytes, units) {
  let unitIndex = 0;
  while (bytes >= 1024 && unitIndex < units.length - 1) {
    bytes /= 1024;
    unitIndex++;
  }

  const formattedValue = bytes.toFixed(2);
  const unit = units[unitIndex];

  return `${formattedValue} ${unit}`;
}
